import React, { useState } from 'react';
import { Cancel01Icon, InternetIcon } from 'hugeicons-react';
import { useChatContext } from '../../contexts/AppDataContext';
import '../../Styles/Layout/WebSearchToggle.css';

const WebSearchToggle: React.FC = () => {
  const { useWeb, toggleWebSearch } = useChatContext();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  if (!useWeb) return null;

  return (
    <div className="web-search-toggle" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button
        type="button"
        className={`input-area-pill web-search-button`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggleWebSearch();
        }}
        aria-label={useWeb ? 'Disable web search' : 'Enable web search'}
        title={useWeb ? 'Web search enabled' : 'Enable web search'}
      >
        {isHovered ? (
          <Cancel01Icon
            size={16}
            className="cancel-search-icon"
            aria-hidden="true"
          />
        ) : (
          <InternetIcon
              size={16}
              className="web-search-icon"
              aria-hidden="true"
            />
          )}
        <span className="web-search-text">
          Search
        </span>
      </button>
    </div>
  );
};

export default WebSearchToggle;

